// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i9-0";
export var actionModalContentContainer = "_i9-1";
export var createTagButton = "_i9-2";
export var footerContainer = "_i9-7";
export var fullWidthDivider = "_i9-3";
export var hasCreateTagButton = "_i9-4";
export var noCreateTagButton = "_i9-5";
export var tagsContainer = "_i9-6";
export var tagsModalContentContainer = "_i9-8";